import { IHttpService, ILocationService, IScope } from "angular";

angular.module('logbook')
	.controller('validate-email', ['$scope', '$http', '$location',
		function($scope: IScope, $http: IHttpService, $location: ILocationService) {

			$scope.emailValidation = {
				email: $location.search().email,
				code: $location.search().code
			};
			$location.search({});

			if ($scope.emailValidation.code) {
				$http.post('/api/emailValidation', $scope.emailValidation)
				.then(result => {
					if (result.data)
						$location.url('/')
							.search('emailValidationSuccess', 'true')
							.search('email', $scope.emailValidation.email);
					else
						$location.url('/')
							.search('emailValidationFailed', 'true');
				});
			}
		}
	]);